// extracted by mini-css-extract-plugin
export default {"wrap":"SemiFinishedProductListModal_wrap__dXBwk","noData":"SemiFinishedProductListModal_noData__qIBBf"};